module.exports = __webpack_public_path__ + "img/what'snew-locked.49c704f9.png";